import request from "/utils/request";

export default () => {
  return request
    .get("/api/plans")
    .then(config => {
      if (config) {
        return config;
      } else {
        throw new Error("No plans found.");
      }
    });
};
